export const CHANGE_ROUTE = 'CHANGE_ROUTE'

export const changeRoute = url => ({ type: CHANGE_ROUTE, payload: url })
